import {useQuery} from "@tanstack/react-query";
import {readProductGroupApi} from "../../../../api/support/common";

/**
 * 제품군 목록 hook
 * @returns
 */
export const useReadProductGroup = () => {
    const res = useQuery({
        queryKey: ["readProductGroup"],
        queryFn: async () => await readProductGroupApi(),
        // staleTime: 6000 * 10,
        select: (res) => res?.result?.ProductGroupList
    });

    return res;
};
